import { TAnswersState } from '../../../containers/FormContainer/types/internal';
import { EAnswerField } from '../../../repositories/lead-realtor-form/entities/schema/ConditionSchema';
import { filter, isNil, path, pathOr } from 'ramda';

export const getPagePart = (answersState: TAnswersState) => {
  return pathOr('main', [EAnswerField.DealTypeEx, 'value'], answersState);
};

export const getNewBuilding = (answersState: TAnswersState) => {
  return path([EAnswerField.FirstOrSecond, 'value'], answersState);
};

export const getOfferType = (answersState: TAnswersState) => {
  return path([EAnswerField.OfferType, 'value'], answersState);
};

export const getObjectType = (answersState: TAnswersState) => {
  return path([EAnswerField.ObjectType, 'value'], answersState);
};

export const getType = (answersState: TAnswersState, field?: string | null) => {
  return filter(
    value => !isNil(value),
    [
      getPagePart(answersState),
      getOfferType(answersState),
      getObjectType(answersState),
      getNewBuilding(answersState),
      field,
    ],
  ).join('/');
};
